<mat-card>
  <mat-card-header>
    <mat-card-title>Post identify page</mat-card-title>
    <mat-card-subtitle>&nbsp;</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Self</mat-panel-title>
          <mat-panel-description>The content of your session</mat-panel-description>
        </mat-expansion-panel-header>
        @if (self()) {
          <pre>{{ self() | json }}</pre>
        }
        <button (click)="getSelf()" matButton="outlined">Update</button>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Access token</mat-panel-title>
          <mat-panel-description>The backend access token.</mat-panel-description>
        </mat-expansion-panel-header>
        <div>
          <div class="access-token">{{ authService.accessToken().accessToken }}</div>
        </div>
        <div>{{ authService.accessToken().refreshToken }}</div>
        <div>
          <div>{{ authService.accessToken().expires | date: 'HH:mm:ss, yyyy-MM-dd' }}
            ( {{ authService.accessToken().expires }} )
          </div>
        </div>
        @for (scope of authService.accessToken().scopes; track $index) {
          <div>{{ scope }}</div>
        } @empty {
          <div>No scopes</div>
        }
        <pre>{{ authService.accessToken() | json }}</pre>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>GitLab</mat-panel-title>
          <mat-panel-description>Your GitLab credentials</mat-panel-description>
        </mat-expansion-panel-header>
        <pre>{{ authService.gitLabToken() | json }}</pre>
        <button (click)="listGroups()" matButton="outlined">Projects</button>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
